import { composeIO } from 'react-compose-io'
import { modalGrupoRegraIO } from './ModalGrupoRegra.IO'
import ModalGrupoRegraView from './ModalGrupoRegra.View'

export const ModalGrupoRegra = composeIO(ModalGrupoRegraView, modalGrupoRegraIO)
